// extracted by mini-css-extract-plugin
module.exports = {"Page":"CreatePassword_Page__17kiD","HiddenCaret":"CreatePassword_HiddenCaret__1jJGW"};